interface ShouldUseExistingHotelDetailsParams {
  isViewMode?: boolean
  sharingCode?: string
  currentHotelSharingCode?: string
}

export const shouldUseExistingHotelDetails = ({
  isViewMode,
  sharingCode,
  currentHotelSharingCode,
}: ShouldUseExistingHotelDetailsParams) =>
  !!isViewMode || (!!sharingCode && currentHotelSharingCode === sharingCode)
